import CheckboxInput from '@/core/components/inputs/CheckboxInput/CheckboxInput';

export default CheckboxInput;
